// Participant color palette (visually distinct on dark backgrounds)
export const PARTICIPANT_COLORS = [
  '#22d3ee', // cyan
  '#a78bfa', // violet
  '#f472b6', // pink
  '#34d399', // emerald
  '#fbbf24', // amber
  '#60a5fa', // blue
  '#fb923c', // orange
  '#e879f9', // fuchsia
]

export const hashString = (str: string) => {
  let hash = 0
  for (let i = 0; i < str.length; i++) hash = ((hash << 5) - hash + str.charCodeAt(i)) | 0
  return Math.abs(hash)
}
